import React from 'react';
import {saveAs} from 'file-saver';
import {downloadShumaFiles} from '../../_redux/actions/shumaActions';
import {can} from '../../../_common/components/Permissions';
import {permissionTypes as T, subjects as S} from '../../../_common/constants/permissionSubjects';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import ButtonAction from '../../../_common/components/ButtonAction';

const ButtonDownloadFiles = ({shumaID, firmShumaID}) => {
  const handleDownload = async () => {
    try {
      const result = await downloadShumaFiles(shumaID);
      saveAs(result, `Inspection_${firmShumaID}_files`);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <ButtonAction
      iconButtonType={'secondary'}
      variant={'icon'}
      label={
        <img
          src={toAbsoluteUrl('/media/common/Download_secondary.svg')}
          alt="download" className="w-20px h-20px"
        />
      }
      customClassnames={'my-1'}
      title={TTS.DOWNLOAD_ALL_FILES}
      onClick={() => handleDownload()}
      disabled={!can(T.FULL, S.INSPECTIONS_PAGE)}
    />
  );
};

export default ButtonDownloadFiles;